const initializeSwiper = () => {
	// Hero Carousel
	document.querySelectorAll('.hero-carousel').forEach((el) => {
		if (el.querySelectorAll('.swiper-slide').length <= 1) return;

		const isAutoplayEnabled = el.classList.contains('autoplay-enabled');

		const heroCarousel = new Swiper(el, {
			navigation: {
				nextEl: el.querySelector('.hero-controls .swiper-button-next'),
				prevEl: el.querySelector('.hero-controls .swiper-button-prev'),
			},
			autoplay: isAutoplayEnabled ? {
				delay: 15000,
				disableOnInteraction: true,
			} : false,
			disableOnInteraction: true,
			mousewheel: {
				forceToAxis: true,
			},
			speed: 800,
			slidesPerView: 1,
			loop: true,
		});
	});


	// Category Carousel
	document.querySelectorAll('.category-carousel').forEach((el) => {
		if (el.querySelectorAll('.swiper-slide').length <= 1) return;

		const wrapper = el.closest('.category-carousel-wrapper');
		const isAutoplayEnabled = wrapper && wrapper.classList.contains('autoplay-enabled');
		const paginationEl = el.querySelector('.category-carousel-pagination .swiper-pagination, .category-carousel-controls .swiper-pagination');

		const categoryCarousel = new Swiper(el, {
			navigation: {
				nextEl: el.querySelector('.category-carousel-pagination .swiper-button-next, .category-carousel-controls .swiper-button-next'),
				prevEl: el.querySelector('.category-carousel-pagination .swiper-button-prev, .category-carousel-controls .swiper-button-prev'),
			},
			pagination: paginationEl ? {
				el: paginationEl,
				type: 'fraction',
			} : undefined,
			speed: 800,
			loop: false,
			slidesPerView: 1,
			centeredSlides: false,
			autoplay: isAutoplayEnabled ? {
				delay: 1500,
				disableOnInteraction: true,
			} : false,
		});

		const perCardPrev = el.querySelectorAll('.category-card-nav-prev');
		const perCardNext = el.querySelectorAll('.category-card-nav-next');

		perCardPrev.forEach((btn) => btn.addEventListener('click', () => categoryCarousel.slidePrev()));
		perCardNext.forEach((btn) => btn.addEventListener('click', () => categoryCarousel.slideNext()));

		const updatePerCardNavState = () => {
			perCardPrev.forEach((btn) => {
				btn.disabled = categoryCarousel.isBeginning;
				btn.classList.toggle('swiper-button-disabled', categoryCarousel.isBeginning);
			});
			perCardNext.forEach((btn) => {
				btn.disabled = categoryCarousel.isEnd;
				btn.classList.toggle('swiper-button-disabled', categoryCarousel.isEnd);
			});
		};
		categoryCarousel.on('slideChange', updatePerCardNavState);
		updatePerCardNavState();
	});


	//Feature Content Carousel
	document.querySelectorAll('.featured-content-carousel').forEach((el) => {
		const isAutoplayEnabled = el.classList.contains('autoplay-enabled');

		new Swiper(el, {
			navigation: {
				nextEl: el.querySelector('.swiper-button-next'),
				prevEl: el.querySelector('.swiper-button-prev'),
			},
			pagination: {
				el: el.querySelector('.swiper-pagination'),
				clickable: true,
			},
			mousewheel: {
				forceToAxis: true,
			},
			speed: 800,
			loop: true,
			slidesPerView: 1,
			centeredSlides: true,
			autoplay: isAutoplayEnabled ? {
				delay: 15000,
				disableOnInteraction: true,
			} : false,
			breakpoints: {
				1024: {
					slidesPerView: 1.25
				}
			}
		});
	});


	// Story Carousel
	document.querySelectorAll('.story-carousel').forEach((el) => {
		const isAutoplayEnabled = el.classList.contains('autoplay-enabled');

		new Swiper(el, {
			navigation: {
				nextEl: el.querySelector('.swiper-button-next'),
				prevEl: el.querySelector('.swiper-button-prev'),
			},
			mousewheel: {
				forceToAxis: true,
			},
			autoplay: isAutoplayEnabled ? {
				delay: 15000,
				disableOnInteraction: true,
			} : false,
			speed: 300,
			loop: true,
			slidesPerView: 1.25,
			centeredSlides: false,
			spaceBetween: 20,
			breakpoints: {
				768: {
					slidesPerView: 2.5,
				},
				1024: {
					slidesPerView: 3.5,
					spaceBetween: 24
				}
			}
		});
	});


	// Compare Carousel
	document.querySelectorAll('.compare-wrapper .swiper').forEach((el) => {
		const wrapper = el.closest('.compare-wrapper');
		const controls = wrapper ? wrapper.querySelector('.compare-carousel-controls') : null;
		const totalSlides = el.querySelectorAll('.swiper-slide').length;

		if (totalSlides <= 1) {
			if (controls) {
				controls.hidden = true;
			}

			return;
		}

		const isAutoplayEnabled = el.classList.contains('autoplay-enabled');
		const paginationEl = controls ? controls.querySelector('.swiper-pagination') : null;

		new Swiper(el, {
			navigation: {
				nextEl: controls ? controls.querySelector('.swiper-button-next') : null,
				prevEl: controls ? controls.querySelector('.swiper-button-prev') : null,
			},
			pagination: paginationEl ? {
				el: paginationEl,
				type: 'fraction',
			} : undefined,
			loop: false,
			speed: 300,
			slidesPerView: 1.1,
			centeredSlides: false,
			spaceBetween: 15,
			autoplay: isAutoplayEnabled ? {
				delay: 15000,
				disableOnInteraction: true,
			} : false,
		});
	});

	// Solution Carousel
	document.querySelectorAll('.solution-carousel').forEach((el) => {
		const isAutoplayEnabled = el.classList.contains('autoplay-enabled');

		new Swiper(el, {
			navigation: {
				nextEl: el.querySelector('.swiper-button-next'),
				prevEl: el.querySelector('.swiper-button-prev'),
			},
			loop: false,
			speed: 300,
			slidesPerView: 1.5,
			centeredSlides: false,
			spaceBetween: 15,
			breakpoints: {
				768: {
					slidesPerView: 2.5
				},
				1024: {
					spaceBetween: 25,
					slidesPerView: 3.5
				},
				1440: {
					spaceBetween: 25,
					slidesPerView: 4.25
				}
			},
			autoplay: isAutoplayEnabled ? {
				delay: 15000,
				disableOnInteraction: true,
			} : false,
		});
	});
};


document.addEventListener("DOMContentLoaded", () => {
    setTimeout(initializeSwiper, 1000);
});
